import React from "react";

const FinCheckContext = React.createContext({

});
export default FinCheckContext;